// extracted by mini-css-extract-plugin
module.exports = {"tabGroup":"tabGroup_tabGroup__3fUWR","tab":"tabGroup_tab__2Q4lc","tabActive":"tabGroup_tabActive__3za8P"};